import React from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import { ReactComponent as ChevronRight } from 'presentation/assets/icons/chevron-right.svg'
import * as S from './styles'

interface ProcedureRecommendationCardProps {
  code: number
  description: string
  isFiltered?: boolean
  onSelect?: () => void
}

export function ProcedureRecommendationCard({
  code,
  description,
  isFiltered = false,
  onSelect
}: ProcedureRecommendationCardProps) {
  return (
    <S.Wrapper>
      <S.TopBar isFiltered={isFiltered} />
      <CardNew
        shadow="none"
        background="neutral25"
        onClick={onSelect}
        style={{ height: '100%' }}
      >
        <S.Code>Cód. {code}</S.Code>
        <S.Description>{description}</S.Description>
        <S.SelectButton>
          Selecionar procedimento
          <S.ArrowIconWrapper>
            <ChevronRight />
          </S.ArrowIconWrapper>
        </S.SelectButton>
      </CardNew>
    </S.Wrapper>
  )
}
